export enum pdpMicrocopy {
  PDP_GALLERY_MODAL_QUALITY = 'PDP_GALLERY_MODAL_QUALITY',
  PDP_WARRANTY_TITLE = 'PDP_WARRANTY_TITLE',
  PDP_WARRANTY_EXTENDED_MANUFACTURER = 'PDP_WARRANTY_EXTENDED_MANUFACTURER',
  PDP_REMAINING_WARRANTY_ELIGIBLE_CONTENT = 'PDP_REMAINING_WARRANTY_ELIGIBLE_CONTENT',
  PDP_ONLY_ELIGIBLE_CONTENT = 'PDP_ONLY_ELIGIBLE_CONTENT',
  PDP_WARRANTY_MODAL_LINK_LABEL = 'PDP_WARRANTY_MODAL_LINK_LABEL',
  PDP_FINANCE_ENQUIRY_FORM_HEADER = 'PDP_FINANCE_ENQUIRY_FORM_HEADER',
  PDP_FINANCE_ENQUIRY_FORM_MESSAGE_FIELD_LABEL = 'PDP_FINANCE_ENQUIRY_FORM_MESSAGE_FIELD_LABEL',
  PDP_FINANCE_ENQUIRY_FORM_DETAIL_SECTION_TITLE = 'PDP_FINANCE_ENQUIRY_FORM_DETAIL_SECTION_TITLE ',
  PDP_FINANCE_ENQUIRY_FORM_FIRST_NAME_LABEL = 'PDP_FINANCE_ENQUIRY_FORM_FIRST_NAME_LABEL',
  PDP_FINANCE_ENQUIRY_FORM_LAST_NAME_LABEL = 'PDP_FINANCE_ENQUIRY_FORM_LAST_NAME_LABEL',
  PDP_FINANCE_ENQUIRY_FORM_EMAIL_ADDRESS_LABEL = 'PDP_FINANCE_ENQUIRY_FORM_EMAIL_ADDRESS_LABEL',
  PDP_FINANCE_ENQUIRY_FORM_PHONE_NUMBER_LABEL = 'PDP_FINANCE_ENQUIRY_FORM_PHONE_NUMBER_LABEL',
  PDP_FINANCE_ENQUIRY_FORM_SUBMIT_BUTTON_LABEL = 'PDP_FINANCE_ENQUIRY_FORM_SUBMIT_BUTTON_LABEL',
  PDP_FINANCE_ENQUIRY_FORM_ERROR_MESSAGE = 'PDP_FINANCE_ENQUIRY_FORM_ERROR_MESSAGE',
  PDP_CARMA_CORE_VALUE_PROPS_TITLE_1 = 'PDP_CARMA_CORE_VALUE_PROPS_TITLE_1',
  PDP_CARMA_CORE_VALUE_PROPS_TITLE_2 = 'PDP_CARMA_CORE_VALUE_PROPS_TITLE_2',
  PDP_CARMA_CORE_VALUE_PROPS_TITLE_3 = 'PDP_CARMA_CORE_VALUE_PROPS_TITLE_3',
  PDP_CARMA_CORE_VALUE_PROPS_TITLE_4 = 'PDP_CARMA_CORE_VALUE_PROPS_TITLE_4',
}
